const started = new Map<string, Promise<unknown>>();

export const startEarly = <T>(key: string, request: () => Promise<T>): Promise<T> => {
  const promise = request();
  promise.catch(() => undefined);
  started.set(key, promise);
  return promise;
};

export const takeEarly = <T>(key: string, request: () => Promise<T>): Promise<T> => {
  const early = started.get(key) as Promise<T> | undefined;
  started.delete(key);
  return early ?? request();
};
